import ProvenienzeHeader from "./ProvenienzeHeader";
export default ProvenienzeHeader;